import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { BsCardText } from '@react-icons/all-files/bs/BsCardText';
import { useContextSelector } from 'use-context-selector';

import { EditorPlaceholder } from '../../../components/EditorPlaceholder';
import { EditorContext } from '../../../contexts';
import { useEditorNode } from '../../../hooks';
import { DocumentPath } from '../../../types';
import { useTabContext } from '../Tab';

interface TabContentProps {
  children: React.ReactNode;
  index: number;
  path: DocumentPath;
}

export function TabContent({ children, index, path }: TabContentProps) {
  const { currentIndex } = useTabContext();
  const isCurrentTab = index === currentIndex;

  useEditorInitializer({ index, path });

  return (
    <Container isHidden={!isCurrentTab}>
      { children || (
        <EditorPlaceholder
          icon={<BsCardText />}
          message="아이템을 추가해주세요."
        />
      ) }
    </Container>
  );
}

function useEditorInitializer({
  index,
  path,
}: {
  index: number,
  path: DocumentPath,
}) {
  const isInEditor = !!useContextSelector(EditorContext, (context) => context);
  const { isChildSelected } = useEditorNode(path);
  const { selectIndex } = useTabContext();

  useEffect(() => {
    if (!isInEditor) { return; }
    if (!isChildSelected) { return; }
    selectIndex(index);
  }, [isChildSelected]);
}

const Container = styled.div<{ isHidden: boolean }>`
  ${({ isHidden }) => isHidden && 'display: none;'}
`;
